<section class="case-studies-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header text-center">
            <h2 class="section-title">Case <span>Studies</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">Real-world impact and success stories</p>
        </div>

        <!-- Case Studies Grid -->
        <div class="case-studies-grid">
            <div class="case-study-card" *ngFor="let study of caseStudies">
                <div class="card-icon">
                    <mat-icon>{{ study.icon }}</mat-icon>
                </div>
                <div class="card-content">
                    <h3 class="study-title">{{ study.title }}</h3>
                    <h4 class="study-subtitle">{{ study.subtitle }}</h4>
                    <p class="study-description">{{ study.description }}</p>
                </div>
            </div>
        </div>
    </div>
</section>